import ElementContent from '@/components/sections/builder/elements/body/image-with-text/content';
import ElementSetting from '@/components/sections/builder/elements/body/image-with-text/setting';
import ImageWithTextButton from '@/components/sections/builder/elements/body/image-with-text/button';
import ImageWithTextSubtitle from '@/components/sections/builder/elements/body/image-with-text/subtitle';
import ImageWithTextTitle from '@/components/sections/builder/elements/body/image-with-text/title';
import { ImageWithTextElementDataType } from '@/components/sections/builder/elements/body/image-with-text/types';
import { GalleryThumbnails } from 'lucide-react';

const defaultData: ImageWithTextElementDataType = {
  name: 'Image with text',
  contentAlign: 'left',
  contentAlignMobile: 'left',
  imagePosition: 'right',
  imageSize: 'medium',
  imageHeight: 'small',
  contentPosition: 'top',
  backgroundAnimation: 'none',
  contentOverlap: 'no-overlap',
  image: 'https://placehold.co/300x200',
  roundedCard: false,
};

export const ElementPreviewIcon = GalleryThumbnails;

const ImageWithText = {
  type: 'image_with_text',
  group: 'body',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [ImageWithTextTitle, ImageWithTextSubtitle, ImageWithTextButton],
  childs: [ImageWithTextTitle, ImageWithTextSubtitle, ImageWithTextButton],
};

export default ImageWithText;
